/**
 * Created by or_p on 6/24/2016.
 */
import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';
import * as Colors from 'material-ui/styles/colors';
import RaisedButton from 'material-ui/RaisedButton';
import Paper from 'material-ui/Paper';
import FontIcon from 'material-ui/FontIcon';
import _ from 'lodash';
import * as Consts from './Consts.js';
import AbsoluteGrid from './AbsoluteGrid';
import {isDraft} from 'crazyEditor/redux/modules/element/elementSelectors';
import { store } from 'crazyEditor/redux/store';
import ImageUploader from 'MyAccount/ViewDesigns/components/Wizard/ImageUploader';

export default class GalleryOrganizer extends PureComponent {

  constructor(props) {
    super();
    let index = 0;
    const {images} = props;
    _.forEach(images, (image, key) => {
      image.order = index++;
      image.key = key;
    });
    this.state = {
      columns: 5,
    };
  }

  componentWillMount() {
    window.addEventListener('resize', () => this.getColumns());
  }

  componentDidMount() {
    this.getColumns();
  }

  componentWillReceiveProps(nextProps) {
    const nextImages = nextProps.images;
    let maxOrder = -1;
    if (this.props.images !== nextImages) {
      _.forEach(nextImages, (image) => {
        if (_.isNumber(image.order)) {
          maxOrder = Math.max(maxOrder, image.order);
        }
      });
      let nextOrder = maxOrder + 1;
      _.forEach(nextImages, (image, key) => {
        if (_.isNil(image.order)) {
          image.order = nextOrder++;
          image.key = key;
        }
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this.getColumns());
  }

  onRemoveImagesClicked(imageIndex) {
    const {onRemoveImagesClicked, images} = this.props;
    const removedOrder = images[imageIndex].order;
    _.forEach(images, (image) => {
      if (image.order > removedOrder) {
        image.order--;
      }
    });
    onRemoveImagesClicked(imageIndex);
  }

  onChangeOrder = (from, to) => {
    const {images} = this.props;
    _.forEach(images, (image) => {
      const {order} = image;
      if (order === from) {
        image.order = to;
      } else if (from < to) {
        if (order > from && order <= to) {
          image.order--;
        }
      } else if (from > to) {
        if (order < from && order >= to) {
          image.order++;
        }
      }
    });
    this.forceUpdate();
  };

  getColumns() {
    const columns = _.floor(window.innerWidth * Consts.DIALOG_WIDTH_PERCENT / ( Consts.IMAGE_SIZE + Consts.IMAGE_MARGIN));
    if (this.state.columns !== columns) {
      this.setState({ columns });
    }
  }

  getAddButtonPosition = () => {
    const {images} = this.props;
    const imagesAmount = _.size(images);
    const gridColumnsAmount = this.getColumnsAmount();
    const gridRowsAmount = _.floor(imagesAmount / gridColumnsAmount);
    const imagesInLastRowAmount = imagesAmount - (gridRowsAmount * gridColumnsAmount);
    const top = Consts.ABSOLUTE_GRID_MARGIN_TOP + (gridRowsAmount * (Consts.IMAGE_SIZE + Consts.IMAGE_MARGIN));
    const left = Consts.ABSOLUTE_GRID_MARGIN_LEFT + (imagesInLastRowAmount * (Consts.IMAGE_SIZE + Consts.IMAGE_MARGIN));
    return {left, top};
  };

  getColumnsAmount = () => {
    return this.props.columns ? this.props.columns : this.state.columns;
  };

  showAddButton() {
    const { bulkReviseEnabled } = this.props;
    let show = true;
    if (bulkReviseEnabled) {
      show = isDraft(store.getState());
    }
    return show;
  }

  disableDragAndDrop() {
    const { bulkReviseEnabled } = this.props;
    let disable = false;
    if (bulkReviseEnabled) {
      disable = !isDraft(store.getState());
    }
    return disable;
  }

  render() {
    const {onAddImagesClicked, images, disabled, bulkReviseEnabled, listingData} = this.props;
    if (bulkReviseEnabled && _.isEmpty(listingData) && !isDraft(store.getState())) {
      _.forEach(images, (item, key) => {
        item.preview = `https://misc.crazylister.com/bulkPlaceholders/thumbnails/Bulk%20gallery%20placeholder%20${item.order + 1}.svg`;
        item.src = `https://misc.crazylister.com/bulkPlaceholders/thumbnails/Bulk%20gallery%20placeholder%20${item.order + 1}.svg`;
      });
    }
    const addButtonPosition = this.getAddButtonPosition();
    return (
      <div style={{position: 'relative'}}>
        <AbsoluteGrid
          columns={this.getColumnsAmount()}
          elementHeight={Consts.IMAGE_SIZE}
          elementWidth={Consts.IMAGE_SIZE}
          margin={Consts.IMAGE_MARGIN}
          style={{margin: 'auto', width: 750, marginTop: Consts.ABSOLUTE_GRID_MARGIN_TOP, marginLeft: Consts.ABSOLUTE_GRID_MARGIN_LEFT}}
          onChangeOrder={this.onChangeOrder}
          disableDragAndDrop={this.disableDragAndDrop()}
          keepLastElementInPlace
        >
          {
            _.map(images, (image, index) => {
              return (
                <Paper
                  key={image.key}
                  style={{width: Consts.IMAGE_SIZE, height: Consts.IMAGE_SIZE}}
                  zDepth={2}
                >
                  <ImageUploader
                    image={image}
                    imageSize={Consts.IMAGE_SIZE}
                    onClickRemove={() => {this.onRemoveImagesClicked(index);}}
                    ref = "imageUploader"
                    previewEnabled = {false}
                    disabled={this.disableDragAndDrop()}
                  />
                </Paper>
              );
            })
          }
        </AbsoluteGrid>
        {
          !disabled && this.showAddButton() &&
          <RaisedButton
            order={_.size(images)}
            style={{left: addButtonPosition.left, top: addButtonPosition.top, position: 'absolute', width: Consts.IMAGE_SIZE + 'px', height: Consts.IMAGE_SIZE + 'px', textAlign: 'center'}}
            labelStyle={{fontSize: 18, color: Colors.grey600, textTransform: 'none', textAlign: 'center', lineHeight: null, height: Consts.IMAGE_SIZE, display: 'flex'}}
            label={<span style={{flexDirection: 'column', justifyContent: 'center', display: 'flex', width: '100%'}}><div style={{marginBottom: 15}}>Add Images</div><FontIcon color={Colors.grey600} className="material-icons" >add</FontIcon></span>}
            onClick={onAddImagesClicked}
            wrap
          />
        }
      </div>
    );
  }
}


GalleryOrganizer.propTypes = {
  onAddImagesClicked: PropTypes.func.isRequired,
  onRemoveImagesClicked: PropTypes.func,
  images: PropTypes.array,
  disabled: PropTypes.bool,
};